import { MutableRefObject } from 'react';

import {
    NavigationUpdateContextType,
    ParamsType,
    ScreenType,
} from 'modules/common/components/Navigator/context/NavigatorContext.interface';

export enum DrawerTypes {
    MESSAGE_CENTER = 'messageCenter',
    HELP_AGENT = 'helpAgent',
    INBOX = 'inbox',
}

export type DrawerType = DrawerTypes | null;

export interface PendingHelpAgentWidgetData {
    message: string;
    source?: string;
}

export interface IMCContextType {
    currOpenDrawer: DrawerType;
    prevOpenDrawer: DrawerType;
    openDrawer: (newDrawer: DrawerType, initialScreen?: ScreenType, params?: ParamsType) => void;
    messageCenterNavigationRef: MutableRefObject<NavigationUpdateContextType | null>;
    hasUnreadMessages: boolean;
    setHasUnreadMessages: (value: boolean) => void;
    isHelpAgentReady: boolean;
    setIsHelpAgentReady: (value: boolean) => void;
    initialTicketId: number | null;
    pendingHelpAgentMessage: string | null;
    setPendingHelpAgentMessage: (message: string | null) => void;
    pendingHelpAgentWidgetData: PendingHelpAgentWidgetData | null;
    setPendingHelpAgentWidgetData: (data: PendingHelpAgentWidgetData | null) => void;
    activeRightSidebarId: string | null;
    registerRightSidebar: (id: string) => void;
    unregisterRightSidebar: (id: string) => void;
    // Help Agent Widget state
    isHelpAgentWidgetOpen: boolean;
    openHelpAgentWidget: (opts?: { message?: string; source?: string }) => void;
    closeHelpAgentWidget: () => void;
    // Hide Help Agent FAB (used by dialogs/wizards to hide FAB when they're open)
    isHelpAgentFabHidden: boolean;
    showHelpAgentFab: () => void;
    hideHelpAgentFab: () => void;
}
